import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import Seo from './components/Seo';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ContactUs from './pages/ContactUs';
// import ReviewForm from './pages/ReviewForm';
// import ReviewSuccess from './pages/ReviewSuccess';
import SolicitarCotización from './pages/SolicitarCotización';

function App() {


  return (
    <div>
      <Router>
        <Seo />
        <Routes>
        
          <Route path="/" element={<Home />} />
          <Route path="/sobre-nosotros" element={<About />} />
          <Route path="/nuestros-servicios" element={<Services />} />
          <Route path="/contáctanos" element={<ContactUs />} />
          <Route path="/cotización" element={<SolicitarCotización />} />

          {/* Reseñas pausadas temporalmente.
          <Route path="/tu-opinión" element={<ReviewForm />} />
          <Route path="/reseña-enviada" element={<ReviewSuccess />} />
          */}
          <Route path="/tu-opinión" element={<Navigate to="/" replace />} />
          <Route path="/reseña-enviada" element={<Navigate to="/" replace />} />
          <Route path="*" element={<main className="container py-5"><h1>Página no encontrada</h1><p>La dirección solicitada no existe.</p><Link to="/">Volver a ELARITECH</Link></main>} />
          




        </Routes>
      </Router>
    </div>
  );
}

export default App;
